<template>
  <el-form-item label="手机号" prop="phone" :error="error">
    <el-input
      v-model="valueBackUp"
      @input="handleChange"
      :disabled="isSearching"
      maxlength="11"
      show-word-limit
      clearable
      placeholder="请输入手机号"
    />
    <el-alert
      v-if="isDiff"
      title="修改手机号后，学员将无法使用原手机号登录小程序，请谨慎操作"
      type="warning"
      show-icon
      :closable="false"
    />
  </el-form-item>
</template>

<script>
import { mapGetters } from 'vuex';
import { getStudentIdByPhone } from '@/api/student';

export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
    excludeStudentId: {
      type: Number,
      default: 0,
    },
    isDiff: Boolean,
  },
  data: () => ({
    valueBackUp: '',
    list: [],
    error: '',
    isSearching: false,
  }),
  watch: {
    value(value) {
      if (value !== this.valueBackUp) this.valueBackUp = value;
    },
    valueBackUp(valueBackUp) {
      if (valueBackUp !== this.value) this.$emit('input', valueBackUp);
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  methods: {
    async handleChange(phone) {
      if (phone.length !== 11 || this.isSearching) return;

      this.isSearching = true;
      const { isError, data } = await getStudentIdByPhone({
        phone,
        exclude_student_id: this.excludeStudentId,
      });
      this.isSearching = false;
      if (isError) return;

      if (data.id) this.error = '该手机号已被使用，请输入其他手机号！';
    }
  },
  beforeMount() {
    this.valueBackUp = this.value;
  },
};
</script>
